var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkshopsActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "827D69F1-9B39-4D14-8663-C68EA9EDE09C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.530381,3.83361905 L1.91704762,3.83361905 C0.859904762,3.83361905 -9.52380952e-05,2.97457143 -9.52380952e-05,1.91647619 C-9.52380952e-05,0.859333333 0.859904762,0.000285714286 1.91704762,0.000285714286 L18.530381,0.000285714286 C19.5875238,0.000285714286 20.4475238,0.859333333 20.4475238,1.91647619 C20.4475238,2.97457143 19.5875238,3.83361905 18.530381,3.83361905",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Workshops",
    transform: "translate(-29.000000, -272.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Side-Nav",
    transform: "translate(0.000000, 89.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "workshops-active",
    transform: "translate(29.000000, 183.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3079048,18.0277143 L11.0755238,15.9362857 L11.0755238,15.3353333 L9.37171429,15.3353333 L9.37171429,15.9362857 L6.14028571,18.0277143 C5.746,18.2829524 5.63266667,18.8105714 5.88790476,19.2058095 C6.0507619,19.4581905 6.32409524,19.5953333 6.60409524,19.5953333 C6.76219048,19.5953333 6.92219048,19.5515238 7.066,19.4581905 L9.37171429,17.9667619 L9.37171429,18.7429524 C9.37171429,19.2134286 9.75361905,19.5953333 10.2231429,19.5953333 C10.693619,19.5953333 11.0755238,19.2134286 11.0755238,18.7429524 L11.0755238,17.9658095 L13.3821905,19.4581905 C13.5240952,19.5515238 13.6850476,19.5953333 13.8440952,19.5953333 C14.1231429,19.5953333 14.3964762,19.4581905 14.5602857,19.2058095 C14.8155238,18.8105714 14.7021905,18.2829524 14.3079048,18.0277143",
    id: "Fill-1",
    fill: "#F88801"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Fill-4",
    fill: "#F88801",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6268571,10.0418095 L9.31828571,12.3970476 C9.2192381,12.4675238 9.10114286,12.505619 8.97828571,12.505619 C8.884,12.505619 8.79161905,12.4827619 8.7087619,12.4408571 C8.51257143,12.3389524 8.39066667,12.1389524 8.39066667,11.918 L8.39066667,7.20847619 C8.39066667,6.98752381 8.51257143,6.78752381 8.7087619,6.68657143 C8.90495238,6.58466667 9.13828571,6.60085714 9.31828571,6.72942857 L12.6268571,9.08466667 C12.7811429,9.19514286 12.8735238,9.3732381 12.8735238,9.56371429 C12.8735238,9.7532381 12.7811429,9.93133333 12.6268571,10.0418095 M18.5306667,4.68561905 L1.91638095,4.68561905 C1.77161905,4.68561905 1.63066667,4.66466667 1.49066667,4.6427619 L1.49066667,12.9922857 C1.49066667,13.8141905 2.1592381,14.4837143 2.98209524,14.4837143 L17.4659048,14.4837143 C18.2878095,14.4837143 18.956381,13.8141905 18.956381,12.9922857 L18.956381,4.6427619 C18.816381,4.66466667 18.676381,4.68561905 18.5306667,4.68561905",
    id: "Fill-7",
    fill: "#F88801"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkshopsActive);
export default __webpack_public_path__ + "static/media/workshops-active.53739b20.svg";
export { ForwardRef as ReactComponent };